import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Skeleton } from "@/components/ui/skeleton";
import { Plus, Trash2 } from "lucide-react";

export default function AdminBuilders() {
  const [items, setItems] = useState(null);
  const [name, setName] = useState("");

  const load = () => api.get("/admin/builders").then((r) => setItems(r.data)).catch(() => setItems([]));
  useEffect(() => { load(); }, []);

  const add = async () => {
    if (!name.trim()) return;
    await api.post("/admin/builders", { name: name.trim(), published: true });
    setName(""); toast.success("Builder added"); load();
  };
  const del = async (b) => { if (!window.confirm(`Delete "${b.name}"?`)) return; await api.delete(`/admin/builders/${b.id}`); toast.success("Deleted"); load(); };

  return (
    <div className="p-6 md:p-10 max-w-2xl">
      <h1 className="font-display text-3xl text-navy">Builders</h1>
      <p className="text-muted-foreground mt-1">Manage developer / builder partners shown on the site.</p>
      <div className="flex gap-2 mt-6">
        <Input value={name} onChange={(e) => setName(e.target.value)} onKeyDown={(e) => e.key === "Enter" && add()} placeholder="Builder name" className="bg-white" data-testid="builder-name-input" />
        <Button onClick={add} data-testid="add-builder-btn" className="bg-gold text-navy hover:bg-gold-dark font-semibold"><Plus className="w-4 h-4 mr-1" /> Add</Button>
      </div>
      {items === null ? <Skeleton className="h-40 rounded-2xl mt-6" /> : (
        <div className="mt-6 grid sm:grid-cols-2 gap-3">
          {items.map((b) => (
            <div key={b.id} className="bg-white rounded-xl border border-gray-100 shadow-card p-4 flex items-center justify-between" data-testid={`builder-admin-${b.id}`}>
              <span className="font-medium text-navy">{b.name}</span>
              <Button size="icon" variant="ghost" onClick={() => del(b)} className="text-red-500"><Trash2 className="w-4 h-4" /></Button>
            </div>
          ))}
          {items.length === 0 && <p className="text-center text-muted-foreground py-6 sm:col-span-2">No builders yet.</p>}
        </div>
      )}
    </div>
  );
}
